module.exports = __webpack_public_path__ + "img/workplace_theater_no_data.f9e23025.svg";